export default __webpack_public_path__ + "static/media/field_icon.e4ba1658.png";